module.exports = __webpack_public_path__ + "static/media/headerBGR.69bda2a4.png";